import dayjs from 'dayjs';

import { autoHyphen } from '@utils/common';
import { getLoginType } from '@lib/enum';
import { HeaderType } from '@utils/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';

type LatestJoinedTableRowProps = {
    header: HeaderType[];
    data: any;
};
const LatestJoinedTableRow = ({ header, data }: LatestJoinedTableRowProps) => {
    return (
        <TableRow $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data?.createdAt).format('YYYY-MM-DD HH:mm')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.loginType ? getLoginType(data?.loginType) : '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.userName || '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.email || '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {data?.cellphone ? autoHyphen(data?.cellphone) : '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {typeof data?.qrAmount === 'number' ? data?.qrAmount : '-'}
            </TableCell>
        </TableRow>
    );
};

export default LatestJoinedTableRow;
